export function parseToBoolean(val: any) {
  return JSON.parse(String(val).toLocaleLowerCase());
}
